// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
const _ = require('lodash');

import { OverlayTrigger, Popover } from 'react-bootstrap';

// Helpers
import PopularContentsHelper from 'components/home-page/popular/popular-content-helper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

export class HomePageNavBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: props.navCategories,
            activeCategory: props.currentCategory
        };

        this.categoriesToShow = {
            xlScreens: 9,
            lgScreens: 7,
            mdScreens: 5,
            smlScreens: 3,
            xsmlScreens: 2
        };

        this.responsiveBreakpoints = {
            xl: 1500,
            lg: 1200,
            md: 992,
            sml: 768
        };
    }

    componentDidMount() {
        this.checkAndSwapItemFromNavIntoMenu(this.state.activeCategory);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.navCategories && _.difference(nextProps.navCategories, this.state.categories).length > 0) {
            this.setState({
                categories: nextProps.navCategories
            });
        }
    }

    swapItemFromNavIntoMenu(item) {
        const swapIndex = this.getSwapIndex();
        const tempArray = this.state.categories.slice();
        const tempVar = tempArray[swapIndex];
        const tempVarIndex = tempArray.indexOf(item);
        tempArray[swapIndex] = item;
        tempArray[tempVarIndex] = tempVar;

        this.setState({
            categories: tempArray
        });
    }

    getSwapIndex() {
        const navBarElemnt = document.querySelector('.homepage--nav');
        const width = navBarElemnt.clientWidth;
        if (width && width > this.responsiveBreakpoints.xl) {
            return this.categoriesToShow.xlScreens - 1;
        } else if (width > this.responsiveBreakpoints.lg) {
            return this.categoriesToShow.lgScreens - 1;
        } else if (width > this.responsiveBreakpoints.md) {
            return this.categoriesToShow.mdScreens - 1;
        } else if (width > this.responsiveBreakpoints.sml) {
            return this.categoriesToShow.smlScreens - 1;
        }

        return this.categoriesToShow.xsmlScreens - 1;
    }

    itemIsInMenu(item) {
        const width = window.innerWidth;
        if (width && width > this.responsiveBreakpoints.xl && this.state.categories.indexOf(item) >= this.categoriesToShow.xlScreens) {
            return true;
        } else if (width <= this.responsiveBreakpoints.xl && width > this.responsiveBreakpoints.lg && this.state.categories.indexOf(item) >= this.categoriesToShow.lgScreens) {
            return true;
        } else if (width <= this.responsiveBreakpoints.lg && width > this.responsiveBreakpoints.md && this.state.categories.indexOf(item) >= this.categoriesToShow.mdScreens) {
            return true;
        } else if (width <= this.responsiveBreakpoints.md && width > this.responsiveBreakpoints.sml && this.state.categories.indexOf(item) >= this.categoriesToShow.smlScreens) {
            return true;
        } else if (width <= this.responsiveBreakpoints.sml && this.state.categories.indexOf(item) >= this.categoriesToShow.xsmlScreens) {
            return true;
        }

        return false;
    }

    switchNavCategory(category, item) {
        this.setState({
            activeCategory: item
        });

        this.checkAndSwapItemFromNavIntoMenu(item);

        mixpanelTracker.reportRecommendationCategoryClick(item);
        this.props.categoryChanged(item);
        this.refs.navBarOverlay.hide();
    }

    checkAndSwapItemFromNavIntoMenu(item) {
        if (this.itemIsInMenu(item)) {
            this.swapItemFromNavIntoMenu(item);
        }
    }

    /*
        This function is used to display the menu of category items that don't fit on the main NavBar
        Always at least 2 (this.categoriesToShow.xsmlScreens) items will be shown on the main navBar & we don't want to show those on the NavMenu
        Therefore we create a new copy of this.state.categories using slice & then splice out the first two elements.
        We then uses the appropriate bootstrap css classNames to determine what contents are hidden and visible.
        If a content is visible in the NavBar then it wont be visible in the Menu & visa versa
        You can see https://getbootstrap.com/docs/3.3/css/#responsive-utilities for more details on visible & hidden classes
     */
    menuContents() {
        const navCategoriesArray = this.state.categories.length > this.categoriesToShow.xsmlScreens ? this.state.categories.slice().splice(2) : [];
        const listItems = navCategoriesArray.map((item, index) =>
            <div
              key={item}
              className={`
                    homepage--nav-menu-item
                    ${index >= this.categoriesToShow.xsmlScreens - 2 ? 'visible-xs' : ''}
                    ${index >= this.categoriesToShow.smlScreens - 2 ? 'visible-sm' : ''}
                    ${index >= this.categoriesToShow.mdScreens - 2 ? 'visible-md' : ''}
                    ${index >= this.categoriesToShow.lgScreens - 2 ? 'visible-lg' : ''}
                    ${index >= this.categoriesToShow.xlScreens - 2 ? 'visible-large' : ''}
              `}
            >
                <span className="togo-font-regular" onClick={category => this.switchNavCategory(category, item)}>
                    <i className="material-icons wn_icon wn_icon__offset--org">{PopularContentsHelper.getCategoryDisplayIcon(item)}</i>
                    {PopularContentsHelper.getCategoryDisplayName(item)}
                </span>
            </div>
        );

        return listItems;
    }

    renderMenu() {
        if (this.state.categories.length <= this.categoriesToShow.xsmlScreens) {
            return null;
        }
        return (
            <Popover className="homepage--nav-menu-popover">
                <div className="homepage--nav-menu togo-font-regular">
                    {this.menuContents()}
                </div>
            </Popover>
        );
    }

    createNavMenuContainer() {
        return (
            <div className="homepage--nav-icon">
                <OverlayTrigger
                  id="navBarOverlay"
                  trigger="click"
                  placement="bottom"
                  rootClose={true}
                  overlay={this.renderMenu()}
                  ref="navBarOverlay"
                >
                    <span><i className="togo-icon togo-icon-2x togo-icon-chevron"></i></span>
                </OverlayTrigger>
            </div>
        );
    }

    /*
        This function determines what popular categories will be displayed in the Nav Bar
        At most, 9 (this.categoriesToShow.lgScreens) will be shown on the screen so we create a copy of the states categories using slice & then we splice out the first 9 elements in the array
        The class names such as hidden-xs will be used to show/hide the appropriate categories in the Nav Bar depending on screen size
        You can see https://getbootstrap.com/docs/3.3/css/#responsive-utilities for more details on visible & hidden classes
     */
    createNavBarContainer() {
        const navCategoriesArray = this.state.categories.length >= this.categoriesToShow.lgScreens ? this.state.categories.slice().splice(0, 9) : this.state.categories;
        const listItems = navCategoriesArray.map((item, index) =>
            <div
              key={item}
              className={`
                    homepage--nav-container
                    ${item === this.state.activeCategory ? 'active' : ''}
                    ${index >= this.categoriesToShow.xsmlScreens ? 'hidden-xs' : ''}
                    ${index >= this.categoriesToShow.smlScreens ? 'hidden-sm' : ''}
                    ${index >= this.categoriesToShow.mdScreens ? 'hidden-md' : ''}
                    ${index >= this.categoriesToShow.lgScreens ? 'hidden-large' : ''}
              `}
            >
                <span
                  className="togo-font-semibold"
                  onClick={
                        category => this.switchNavCategory(category, item)
                  }
                >
                    {PopularContentsHelper.getCategoryDisplayName(item)}
                </span>
            </div>
        );

        return listItems;
    }

    createNav() {
        return (
            <div className="text-center homepage--nav">
                {this.createNavBarContainer()}
                {this.createNavMenuContainer()}
            </div>
        );
    }

    render() {
        return this.createNav();
    }
}

HomePageNavBar.propTypes = {
    navCategories: PropTypes.object,
    currentCategory: PropTypes.string,
    categoryChanged: PropTypes.func
};

export default translate(['translation'])(HomePageNavBar);



// WEBPACK FOOTER //
// ./src/components/home-page/nav-bar/home-page-nav-bar.js